module.exports = __webpack_public_path__ + "img/flag_yes.3c240533.svg";